import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
const passwordResetEmailVerificationSchema = z.object({
    accessToken: z.string(),
});
export class PasswordResetEmailVerificationResponseDto extends createZodDto(passwordResetEmailVerificationSchema) {
}
